import React from 'react';
import classnames from 'classnames';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { Field } from 'redux-form'
import { Utils } from '../../services';

import './MoneyField.css';

const MoneyField = ({ name, compact = false, className, maxLength, ...rest }) => {
    const currency = Utils.currency();

    return (
        <div className={classnames('MoneyField', compact && 'MoneyField--compact', className)}>
            <InputGroup>
                <Field
                    component="input"
                    type="text"
                    className="form-control"
                    name={name}
                    pattern="-{0,1}[0-9]+([\.][0-9]{1,2})?"
                    maxLength={maxLength ?? (compact ? 8 : undefined)}
                    {...rest}
                />
                <InputGroupAddon addonType="append">
                    <InputGroupText>{ currency }</InputGroupText>
                </InputGroupAddon>
            </InputGroup>
        </div>
    );
}

export default MoneyField;
